import { RT_EditorValue, RT_Node } from "./types";
import { LeafRenderStatic, ElementRenderStatic } from "./render";

// ---------------------------------------------------------------------- //

const recursiveRender = (item: RT_Node, key: number) => {
  if (!("type" in item)) {
    return <LeafRenderStatic key={key} leaf={item} />;
  }

  return (
    <ElementRenderStatic key={key} element={item}>
      {item.children.map((_item, _index) => recursiveRender(_item, _index))}
    </ElementRenderStatic>
  );
};

// ---------------------------------------------------------------------- //

type Props = {
  value: RT_EditorValue | null | undefined;
  style?: React.CSSProperties;
};

export function RichTextRenderStatic({ value, style }: Props) {
  if (!value) return null;

  return (
    <div style={style}>
      {value.map((item, index) => recursiveRender(item, index))}
    </div>
  );
}
